import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AuthState, UserInterface } from "../../Interfaces/interfaces";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "../../store/store";

const initialState: AuthState = {
  user: null,
  isLoggedIn: false,
};

export const googleAuth = createSlice({
  name: "googleAuth",
  initialState,
  reducers: {
    signIn: (state: AuthState, action: PayloadAction<UserInterface>) => {
      state.user = action.payload;
      state.isLoggedIn = true;
    },
    signOut: () => initialState,
  },
});

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const { signIn, signOut } = googleAuth.actions;
export const googleAuthReducer = googleAuth.reducer;
